import Tooltip from "antd/lib/tooltip";
import React from "react";
import { getImageBaseUrl } from "../../services/s3-utils";

function OtherMenu(props) {
  return (
    <Tooltip
      placement="bottomRight"
      trigger="click"
      title={
        <ul style={{ backgroundColor: "#fff", width: 150, margin: 0 }}>
          <li
            className="flex justify-between text-dark pointer mb-3"
            onClick={() => window.open("https://business.qalort.com")}
          >
            Qalort Courses
          </li>
        </ul>
      }
    >
      <img
        src={`${getImageBaseUrl}/assets/toggle.svg`}
        className="w-6 md:flex hidden"
        alt=""
      />
    </Tooltip>
  );
}

export default OtherMenu;
